import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import DashboardLayout from "./DashboardLayout";
import UserManagement from "./Usermanagement/Usermanagement";
import baseURL from "../config";
import PageLoader from "../../../Reusable/PageLoader";
const Manageusers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        // Simulate delay for demo

        const response = await fetch(`${baseURL}/admin/users`, {
          method: "GET",
          credentials: "include",
        });

        if (!response.ok) throw new Error("Failed to fetch users");

        const data = await response.json();
        setUsers(data);
      } catch (err) {
        console.error(err);
        toast.error(err.message || "Something went wrong while loading users.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <DashboardLayout>
      <Typography
        variant="h6"
        sx={{
          color: "#666",
          marginBottom: 2,
          textAlign: "left",
          marginTop: 2,
          fontWeight: "600",
        }}
      >
        Manage Users
      </Typography>

      {loading ? (
        <PageLoader message="Loading Users..." subtext="Fetching all users" />
      ) : (
        <UserManagement users={users} />
      )}
    </DashboardLayout>
  );
};

export default Manageusers;
